// maintenanceMode.api.ts
import api from "./axios";

export interface MaintenanceModeStatus {
  enabled: boolean;
  expiresAt: string | null;
  startedBy: number | null;
  sessionId: string | null;
}

export const maintenanceModeApi = {
  status: () => api.get<MaintenanceModeStatus>("/maintenance-mode/status"),
  start: (durationMinutes: number) =>
    api.post<MaintenanceModeStatus>("/maintenance-mode/start", { durationMinutes }),
  end: () => api.post<MaintenanceModeStatus>("/maintenance-mode/end"),
};
